import { useAppSelector } from "../../redux/hook";
import ViewBoardContainer from "../viewBoard/ViewBoardContainer";

const PreviewContainer = ({page = 0, showHeader = false}) => {
    const previewMode = useAppSelector((state) => state.data.preview)
    if (previewMode) {
        return <ViewBoardContainer page={page} showHeader={showHeader} />
    } else {
        return  <div></div>
    }
}

export default PreviewContainer